import React, { useContext } from 'react';

export const FeatureContext = React.createContext({});
FeatureContext.displayName = 'FeatureContext';

export const useFeatures = () => useContext(FeatureContext);

export default FeatureContext;
